import type { ICitaMediAplicados } from '@/modules/Asistencial/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { ISolicitudInventario } from '../interfaces/ISolicitudMedicamentos'
export class SolicitudMedicamentoService extends BaseService<ICitaMediAplicados> {
  constructor() {
    super({
      baseUrl: 'medicines/request/'
    })
  }

  async dispensarMedicamentos(
    payload: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<IResponseApi<string>>(`/dispensar-medicamentos`, payload)
      .catch(this.errorHandle)
  }
  async dispensarInsumos(
    payload: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<IResponseApi<string>>(`/dispensar-insumos`, payload)
      .catch(this.errorHandle)
  }
  async crearSolicitud(
    tipo: 'INSUMO',
    payload: ISolicitudInventario
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<IResponseApi<string>>(`/create/${tipo}`, payload)
      .catch(this.errorHandle)
  }
}
